import { render, staticRenderFns } from "./VideoMetaContainer.vue?vue&type=template&id=03fc205a&scoped=true&"
import script from "./VideoMetaContainer.vue?vue&type=script&lang=js&"
export * from "./VideoMetaContainer.vue?vue&type=script&lang=js&"
import style0 from "./VideoMetaContainer.vue?vue&type=style&index=0&id=03fc205a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fc205a",
  null
  
)

export default component.exports